export const generateItemIndexString = (itemIndex: number, compId: string) =>
  `item-${itemIndex}-${compId}`;
